const fn = {
    // 获取页面所有组件id 列表
    getAllWidgetIdList () {
        const allWidget = window.store.getters.allLayers
        return Object.values(allWidget).map(item => {
            // eslint-disable-next-line camelcase
            const { id, id_name, key, label, type } = item
            return { id, id_name, key, label, type }
        })
    },

    // 根据id 获取组件
    getWidgetById (id) {
        const allWidget = window.store.getters.allLayers
        return allWidget[id]
    },

    setWidgetProps (id, props = {}) {
        window.store.dispatch('setWidgetProps', { id, props })
    },

    // 设置组件显示隐藏
    setWidgetVisibility (id, isShow) {
        window.store.dispatch('setWidgetVisibility', { id, show: isShow })
    },

    /**
     * fetchSource: 手动触发动态数据源
     * @param {Object} req
     * @returns {Promise}
     */
    fetchSource (req) {
        return window.dsCenter && window.dsCenter.fetchSource(req)
    }
}

export default fn
